import { gql } from '@apollo/client';
import { datadogRum } from '@datadog/browser-rum';
import { useState } from 'react';
import { subscriptionsPublicClient } from 'lib/apollo/clients';

export const checkResourcesReady = gql`
  query checkResourcesReady($organizationUid: String!, $locationUid: String!) {
    checkResourcesReady(
      organizationUid: $organizationUid
      locationUid: $locationUid
    )
  }
`;

const useCheckResourcesReady = () => {
  const [error, setError] = useState(false);
  let attempts = 0;

  const setTimeoutStateChange = async (exists, variables, callback) => {
    if (exists) {
      callback();
    } else {
      setTimeout(() => {
        handleCheckResources(variables, callback);
      }, 3000);
    }
  };

  const handleCheckResources = async (variables, callback) => {
    attempts = attempts + 1;
    if (attempts > 10) {
      setError(true);
      callback();
      return;
    }

    try {
      const {
        data: { checkResourcesReady: exists },
      } = await subscriptionsPublicClient.query({
        query: checkResourcesReady,
        variables,
        fetchPolicy: 'network-only',
      });

      setTimeoutStateChange(exists, variables, callback);
    } catch (error) {
      setError(true);
      datadogRum.addError(new Error(error));
    }
  };

  return {
    handleCheckResources,
    error,
  };
};

export default useCheckResourcesReady;
